
import { ADMIN_MEMOIRS, MEMOIRS_DOWNLOAD } from "../../../helper/url_helper";
import { axiosApi } from "../../../services/api";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchMemoirs = createAsyncThunk(
  "memoirs/fetchMemoirs",
  async (params, { rejectWithValue }) => {
    try {
      const res = await axiosApi.get(ADMIN_MEMOIRS, { params });
      // return {
      //   list: res.data.data.users,
      //   count: res.data.data.pagination.total,
      // };
      return res.data;

    } catch (err) {
      return rejectWithValue({
        message: err?.response?.data?.message,
        statusCode: err?.response?.status,
      });

    }
  }
);


export const downloadMemoir = createAsyncThunk(
  "memoirs/downloadMemoir",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosApi.get(MEMOIRS_DOWNLOAD(id));
      // console.log("Download response:", response);
      // const blob = new Blob([response.data]);
      // const url = window.URL.createObjectURL(blob);

      // const link = document.createElement("a");
      // link.href = url;
      // link.download = `memoir-${id}.pdf`;
      // document.body.appendChild(link);
      // link.click();

      // link.remove();
      // window.URL.revokeObjectURL(url);

      const url = response.data.data.downloadUrl;

      //auto download url content -pre signed ulr  expire after 15 minutes
      // const link = document.createElement("a");

      // link.href = url;
      // link.download = ``;
      // document.body.appendChild(link);
      // link.click();

      // link.remove();
      window.open(url, "_blank");


      return true;
    } catch (error) {
      return rejectWithValue("Download failed");
    }
  }
);
